import auth from './en/auth';
import coupons from './en/coupons';
import goals from './en/goals';
import profile from './en/profile';
import feedback from './en/feedback';
import managers from './en/managers';
import businesses from './en/businesses';
import defaultButtons from './en/defaultButtons';
import general from './en/general';
import selection from './en/selection';
import fields from './en/fields';
import prompt from './en/prompt';
import users from './en/users';
import privacy from './en/privacy';
import programs from './en/programs';
import rateChallenge from './en/rateChallenge';
import moods from './en/mood';
import mindfulMinutes from './en/mindfulMinutes';
import termsAndConditions from './en/termsAndConditions';
import sessions from './en/sessions';
import payments from './en/payments';
import help from './en/help';
import statistics from './en/statistics';
import themes from './en/themes';
import journal from './en/journal';
import notifications from './en/notifications';
import unsubscribe from './en/unsubscribe';
import timer from './en/timer';
import moodsNew from './en/moodsNew';
import settings from './en/settings';
import feed from './en/feed';
import landingPages from './en/landingPages';
import activityReport from './en/activityReport';

const messages = {
    en: {
        ...auth,
        ...coupons,
        ...profile,
        ...feedback,
        ...managers,
        ...privacy,
        ...termsAndConditions,
        ...businesses,
        ...sessions,
        ...defaultButtons,
        ...general,
        ...selection,
        ...fields,
        ...prompt,
        ...programs,
        ...payments,
        ...users,
        ...statistics,
        ...users,
        ...help,
        ...rateChallenge,
        ...moods,
        ...themes,
        ...goals,
        ...mindfulMinutes,
        ...journal,
        ...notifications,
        ...unsubscribe,
        ...timer,
        ...moodsNew,
        ...feed,
        ...settings,
        ...landingPages,
        ...activityReport
    }
};

export default messages;
